import GreetingList from "./GreetingList";

export default GreetingList